<template>
  <div>
    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <label for="pais" class="form__label">¿Comparte domicilio con el títular?</label>

          <!-- Group of default radios - option 1 -->
          <div class="form__check">
            <input
              type="radio"
            
              id="SpouseRadioSi"
             
              value="Si"
              v-model="radioValue"
            />
            <label for="SpouseRadioSi">
               <span :class="radioValue =='Si' ? 'form__label-active' : ''"></span>
            Si
            </label>
          </div>

          <!-- Group of default radios - option 2 -->
          <div class="form__check">
            <input
              type="radio"
              id="SpouseRadioNo"
              value="No"
              v-model="radioValue"
            />
            <label for="SpouseRadioNo">
                <span :class="radioValue == 'No' ? 'form__label-active' : ''"></span>
            No
            </label>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
    <div v-if="radioValue == 'No'">
      <mdb-row>
        <mdb-col md="4" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label for="beneficiary-state-home" class="form__label">Estado:</label>
              <input
                type="text"
                v-model="state"
                ref="spouse_state"
                id="beneficiary-state-home"
                class="form__input"
                disabled
              />
              <validation-error :validation="$v.state" />
            </div>
          </div>
        </mdb-col>

        <mdb-col md="4" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label for="beneficiary-city-home" class="form__label">Ciudad:</label>
              <input
                type="text"
                v-model="city"
                ref="spouse_city"
                id="beneficiary-city-home"
                class="form__input"
                disabled
              />
              <validation-error :validation="$v.city" />
            </div>
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="2" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label class="form__label">CP.:</label>
              <input
                v-model="codePostal"
                v-mask="'#####'"
                ref="spouse_cp"
                @change="getLocations"
                type="text"
                class="form__input"
                value
              />
              <validation-error :validation="$v.codePostal" />
            </div>
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="8" style="margin-bottom: 20px;">
          <label class="form__label">Colonia:</label>

          <select v-model="locationId" class="browser-default custom-select">
          <option
            v-for="(item, index) in listColony"
            :key="index"
            :value="item.id"
          >{{ item.colony }}</option>
        </select>
        <validation-error :validation="$v.locationId" />
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="4" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label class="form__label">Calle:</label>
              <input
                v-model="street"
                type="text"
                ref="spouse_street"
                class="form__input"
                value
                style="text-transform: capitalize !important;"
              />
              <validation-error :validation="$v.street" />
            </div>
          </div>
        </mdb-col>

        <mdb-col md="2" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label class="form__label">Nº Ext.:</label>
              <input
                v-model="externalNumber"
                ref="spouse_externalNumber"
                type="text"
                class="form__input"
                value
              />
              <validation-error :validation="$v.externalNumber" />
            </div>
          </div>
        </mdb-col>

        <mdb-col md="2" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label class="form__label">Nº Int.:</label>
              <input type="text" class="form__input" value />
            </div>
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row class="mt-4" v-if="pdfUrl!=null">
        <mdb-col md="6">
          <div class="input-group">
            <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

            <img
              style="margin-top: 10px; cursor: pointer;"
              :src="'/img/icons/'+watchButton"
              @click="viewPdf(pdfUrl)"
              @mouseup="mouseUpIcon('watch')"
              @mousedown="mouseDownIcon('watch')"
              @mouseleave="mouseLeaveIcon('watch')"
            />
          </div>
        </mdb-col>
        <mdb-col md="6"></mdb-col>
      </mdb-row>

      <mdb-row class="mt-4" v-if="pdfUrl==null">
        <mdb-col md="6">
          <label for="buttonUpload" class="form__label">Sube un comprobante de domicilio:</label>
          <div v-show="pdfUrl==null" class="curp-upload">
            <label for="spouseProofAddress" class="btn-label">
              <img :src="'../../img/icons/'+uploadIcon" style="width: 20px;" />
              SUBIR COMPROBANTE
            </label>

            <input
              type="file"
              accept="application/pdf"
              name="file"
              id="spouseProofAddress"
              @change="uploadWorker"
            />
            <!--<validation-error :validation="$v.singleRe.worker"></validation-error>-->
            <validation-error :validation="$v.pdfUrl" />
          </div>
          <div v-show="pdfUrl!=null" class="input-group">
            <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

            <img
              style="margin-top: 10px; cursor: pointer;"
              :src="'/img/icons/'+watchButton"
              @click="viewPdf(pdfUrl)"
              @mouseup="mouseUpIcon('watch')"
              @mousedown="mouseDownIcon('watch')"
              @mouseleave="mouseLeaveIcon('watch')"
            />
          </div>
        </mdb-col>
        <mdb-col md="6"></mdb-col>
      </mdb-row>
    </div>

    <Popup size="lg" ref="confirm" title="Comprobante de Domicilio">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>
      </div>
      <div class="accordion__button">
        <btn
          style="float: left;"
          text="CERRAR"
          @onClick="$refs.confirm.toggleModal()"
          type="primary-block"
        />
      </div>
    </Popup>
  </div>
</template>
<script>
import Btn from "../../core/Button";
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import Popup from "../../core/Popup";
import vSelect from "vue-select";
import ValidationError from "../misc/ValidationError";
import {
  required,
  email,
  minLength,
  alphaNum,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: "SpouseHomeData",
  components: {
    mdbContainer,
    mdbRow,
    vSelect,
    mdbCol,
    Btn,
    Popup,
    ValidationError,
  },
  directives: { mask },
  data() {
    return {
      infoIdIcon: "info-default.svg",
      uploadIcon: "upload-document.svg",
      watchButton: "watch-unpressed-btn.svg",
      codePostal: "",
      listColony: [],
      colony: "",
      state: "",
      city: "",
      street: "",
      externalNumber: "",
      locationId: "",
      pdfUrl: null,
      filesPDF: null,
      popUrl: null,
      userAllData: "",
      personalHomeData: "",
      colonyOnData: false,
      colonyOnfirst: true,
      alreadyUpDocument: false,
      ApplicantSameInfo: false,
      ///////
      radioValue: "No",
    };
  },
  created() {
    this.userAllData = JSON.parse(localStorage.getItem("userAllData"));

    // 1.- DETECTAMOS EL TIPO DE  BENEFIACIARIO (SPOUSE
    let beneficiary = this.userAllData.beneficiaries;
    for (let i = 0; i < beneficiary.length; i++) {
      if (beneficiary[i].beneficiaryType == "SPOUSE") {
        let spouseINFO = beneficiary[i];
        //console.log("spouseINFOHome", spouseINFO);

        if (spouseINFO.address != null) {
          let locID = spouseINFO.address.location.id;
          //console.log("locID", locID);
          this.locationId = locID;
          this.getLocationsByID();
          this.alreadyUpDocument = true;
        }

      
    let profA = spouseINFO.documents.filter(function (item) {
       return item.documentType == "PROOF_OF_ADDRESS";
    })

    if (profA.length>0) {
       this.pdfUrl = profA[0].publicURL;
       this.radioValue = "Si"
    }
      }
    }
  },
  validations: {
    state: {
      required,
    },
    city: {
      required,
    },
    codePostal: {
      required,
    },
    street: {
      required,
    },
    locationId: {
      required,
    },
    externalNumber: {
      required,
    },
    pdfUrl: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      benefName: "getBeneficiaryName",
      addressTitular: "getAddress",
      proofAddress: "getProofAddress",
    }),
    beneficiaryName: {
      get() {
        return this.benefName;
      },
      set(value) {
        this.$store.commit("_setName", value);
      },
    },
  },
  methods: {
    ...mapActions(["obtainLocationsDoc", "obtainLocationByID"]),
    chooseFile() {
      document.getElementById("fileUpload").click();
    },
    chooseFileCurp() {
      document.getElementById("fileUploadCurp").click();
    },
    chooseFileColonia() {
      document.getElementById("fileUploadColonia").click();
    },
    chooseFileCartaAntec() {
      document.getElementById("fileUploadCartaAntec").click();
    },
    chooseFileIdentificacion() {
      document.getElementById("fileUploadIdentificacion").click();
    },
    mouseOverIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
    },
    mouseLeaveIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
    },

    mouseLeaveIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-default.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-default.svg`;
        this.showCard = false;
      }
    },
    mouseDownIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-pressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      }
    },

    viewPdf(url) {
      this.popUrl = url;
      this.$refs.confirm.toggleModal();
    },
    uploadWorker: function (evt) {
      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },

    async getLocations() {
      // //console.log("getLocations...", this.codePostal);
      if (this.codePostal.length == 5) {
        let response = await this.obtainLocationsDoc(this.codePostal);
        // //console.log("response getLocations", response);
        if (response.data) {
          this.listColony = response.data.data;
          this.state = response.data.data[0].state;
          this.city = response.data.data[0].city!=''?response.data.data[0].city:response.data.data[0].municipality;
          this.locationId = response.data.data[0].id;
        }
      }
    },

    async getLocationsByID() {
      let response = await this.obtainLocationByID(this.locationId);
      //console.log("response getLocationsByID", response);
      if (response.data) {
        this.state = response.data.data.state;
        this.city = response.data.data.city;
        this.colony = response.data.data.colony;

        this.codePostal = response.data.data.zipCode;
        this.setNewColonyList();

        this.street = this.userAllData.address.street;
        this.externalNumber = this.userAllData.address.externalNumber;
      }
    },

    async setNewColonyList() {
      let response = await this.obtainLocationsDoc(this.codePostal);
      if (response.data) {
        this.listColony = response.data.data;
        //console.log("listColony", this.listColony);
        this.state = response.data.data[0].state;
        this.city = response.data.data[0].city;
        this.locationId = response.data.data[0].id;
      }
    },

    shareAplicantAddress(value) {
      //console.log("shareAplicantAddress -->", value);
      if (value == true) {
      }
    },

    sameAddress(value) {
      //console.log("sameAddress -->", value);
      if (value == true) {
        this.ApplicantSameInfo = value;
        this.getApplicantHomeData();
      } else {
        this.ApplicantSameInfo = value;
        this.clearApplicantHomeData();
      }
    },

    getApplicantHomeData() {
      if (this.userAllData.address != null) {
        let locID = this.userAllData.address.location.id;
        //console.log("locID", locID);
        this.locationId = locID;
        this.getLocationsByID();
        this.alreadyUpDocument = true;
      }

      let documents = this.userAllData.documents;
      //console.log("documents yyyy", documents);

      let index = documents
        .map(function (obj) {
          return obj.value;
        })
        .indexOf("applicant_proof_of_address");
      if (index == -1) {
      } else {
        this.pdfUrl = documents[index].publicURL;
      }
      this.filesPDF = "-";
    },

    clearApplicantHomeData() {
      this.codePostal = "";
      this.listColony = [];
      this.colony = "";
      this.state = "";
      this.city = "";
      this.street = "";
      this.externalNumber = "";
      this.locationId = "";
      this.pdfUrl = null;
      this.filesPDF = null;
      this.popUrl = null;
      this.personalHomeData = "";
      this.colonyOnData = false;
      this.colonyOnfirst = true;
      this.alreadyUpDocument = false;

    },

    getFormdata() {
      // validations
      this.$v.$touch();
      //console.log("getFormdata chidlHomeData");

      if (!this.$v.$invalid || this.radioValue == "Si") {
        //console.log("IS CORRECT");

        if (this.radioValue == "Si") {
          return true;
        } else {
          // 1.- address

          var fullHomeData = [{ address: {} }, { documents: {} }];

          fullHomeData[0].address = {
            street: this.street,
            externalNumber: this.externalNumber,
            locationId: this.locationId,
          };

          // 1.- email
          fullHomeData[1].documents = {
            documentType: "PROOF_OF_ADDRESS",
            value: "spouse_proof_of_address",
            extension: "pdf",
            mimeType: "application/pdf",
            content: this.filesPDF,
          };

          //console.log("fullContacSpouseData: ", fullContacData);

          return fullHomeData;
        }
      } else {
        return false;
      }
    },
  },
  watch:{
        codePostal(val){
      if(val.length == 5){
        this.getLocations()
      }
    }
  }
};
</script>
<style>
.t1-input-colonia {
  /* max-width: 80%; */
  display: inline;
  transform: translateY(3px);
  margin-bottom: 10px !important;
}

.t1-input-curp {
  display: inline;
  max-width: 70%;
  transform: translateY(3px);
}

.t1-input-dia,
.t1-input-mes {
  text-align: center;
  display: inline;
  width: 8%;
  margin-right: 15px;
  transform: translateY(3px);
}

.t1-input-ano {
  text-align: center;
  display: inline;
  width: 12%;
  transform: translateY(3px);
}

.btn-comprobante-domicilio {
  /* margin-left: 10px; */
  display: inline;
}

.btn-acta-nacimiento {
  display: inline-block;
  margin-left: 10px;
}

.btn-upload-curp {
  display: inline;
  margin-left: 10px;
}

.info-icon {
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  transition: transform 0.2s;
}

.info-icon:hover {
  transform: scale(1.3);
}

.radio-buttons label {
  display: block;
  color: #828282;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-right: 15px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #f78c4f;
  background-color: #f78c4f;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.t2-table-title-left {
  color: #3a8a65;
  font-size: 18px;
}

.t2-table-title-left img {
  width: 20px;
  height: auto;
  margin-top: -0.5rem;
  margin-right: 5px;
}

@media (max-width: 1199px) {
  .t1-input-curp {
    display: block;
    max-width: 100%;
    transform: translateY(3px);
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 12%;
  }

  .t1-input-ano {
    width: 18%;
  }

  .btn-upload-curp {
    display: block;
    margin-top: 10px;
    margin-left: 0px;
  }

  .btn-acta-nacimiento {
    display: block;
    margin-left: 0px;
    margin-top: 10px;
  }
}

@media (max-width: 992px) {
  .btn-comprobante-domicilio {
    margin-left: 0px;
    display: block;
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 18%;
  }

  .t1-input-ano {
    width: 28%;
  }

  .t1-input-colonia {
    max-width: 100%;
    margin-bottom: 10px;
    display: block;
  }
}

@media (max-width: 768px) {
  .t1-input-colonia {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
}
</style>
